<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modalLock"
      title="안내 메시지"
      ok-only
    >
      등록/수정 기간이 아닙니다.<br>
      장학국 간사에게 문의 해주세요!
    </b-modal>
    <b-modal
      ref="modal"
      title="핸드폰 번호로 조회하기"
      hide-footer
      @shown="clearModalMobile"
    >
      <form @submit.stop.prevent="handleModalOk(modalMobile, '')">
        <b-form-group
          name="modalSet"
          label="핸드폰"
          label-for="modalMobile"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="modalMobile"
            v-validate.initial="veeMobileOptional"
            name="modalMobile"
            :state="isValid('modalMobile')"
            placeholder="숫자만"
            @enter="handleModalOk(modalMobile, '')"
          />
        </b-form-group>
        <b-button
          variant="primary"
          block
          @click="handleModalOk(modalMobile, '')"
        >
          조회하기
        </b-button>
        <b-button
          v-for="(can, idx) in candidates"
          :key="idx"
          block
          @click="selectCandidate(can)"
        >
          {{ can['nameSchls'] }}
        </b-button>
      </form>
    </b-modal>
    <!-- Modal Component -->
    <b-modal
      ref="deleteModal"
      hide-footer
      title="기탁서 삭제"
    >
      <p class="my-4">
        기탁서를 삭제하겠습니까?
      </p>
      <b-button
        variant="outline-danger"
        block
        @click="deleteDonateForm()"
      >
        삭제(Delete)
      </b-button>
      <b-button
        variant="outline-primary"
        block
        @click="$refs.deleteModal.hide()"
      >
        취소(Cancel)
      </b-button>
    </b-modal>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <h3><strong>장학 헌금 기탁 후원서</strong></h3>
          </div>
          <b-row align-h="end">
            <b-col
              v-if="registMode"
              sm="3"
              class="text-right"
            >
              <b-btn
                :variant="'success'"
                block
                :size="'md'"
                @click="showModal()"
              >
                <b>내 기탁서 조회하기</b>
              </b-btn>
            </b-col>
            <b-col
              v-else
              sm="3"
              class="text-right"
            >
              <b-btn
                v-show="freezing"
                :variant="'warning'"
                block
                :size="'sm'"
                @click="unsetReadOnly()"
              >
                수정하기
              </b-btn>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-center"
          >
            <b-col><h3>기탁자 정보</h3></b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <b-form-group
                name="partSet"
                label="구분"
                label-for="part"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-select
                  v-model="part"
                  v-validate.initial="veeRequired"
                  name="part"
                  :state="isValid('part')"
                  :disabled="freezing"
                  :options="donatePartOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-show="part !== '개인' && part !== ''"
              md="5"
            >
              <b-form-group
                name="partNameSet"
                :label="part + ' 명칭'"
                label-for="partName"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="partName"
                  name="partName"
                  :state="isValid('part') ? ((part === '' || part === '개인') ? null : partName !== '') : null"
                  :placeholder="part + ' 명칭'"
                  :disabled="freezing"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5">
              <b-form-group
                name="nameKrSet"
                :label="part === '개인' ? '기탁자 이름' : '담당자 이름'"
                label-for="nameKr"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="nameKr"
                  v-validate.initial="veeNameKr"
                  name="nameKr"
                  :state="isValid('nameKr')"
                  placeholder="한글 이름"
                  :disabled="freezing"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                name="titleSet"
                label="직분"
                label-for="title"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-select
                  v-model="title"
                  v-validate.initial="veeRequired"
                  name="title"
                  :state="isValid('title')"
                  :disabled="freezing"
                >
                  <option />
                  <option>렘넌트</option>
                  <option>청년</option>
                  <option>성도</option>
                  <option>집사</option>
                  <option>안수집사</option>
                  <option>권사</option>
                  <option>장로</option>
                  <option>사모</option>
                  <option>전도사</option>
                  <option>준목</option>
                  <option>선교사</option>
                  <option>목사</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                name="mobileSet"
                label="핸드폰"
                label-for="mobile"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="mobile"
                  v-validate.initial="veeMobile"
                  name="mobile"
                  :state="isValid('mobile')"
                  placeholder="숫자만"
                  :disabled="freezing"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                name="nameSchlsSet"
                label="장학금 명칭"
                label-for="nameSchls"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="nameSchls"
                  v-validate.initial="veeRequired"
                  name="nameSchls"
                  :state="isValid('nameSchls')"
                  placeholder=""
                  :disabled="freezing"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                name="giverTypeSet"
                label="장학금 수여자"
                label-for="giverType"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-select
                  v-model="giverType"
                  v-validate.initial="veeRequired"
                  name="giverType"
                  :state="isValid('giverType')"
                  :disabled="freezing"
                >
                  <option>황상배 목사</option>
                  <option>직접</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col
              v-if="giverType === '직접'"
              md="4"
            >
              <b-form-group
                name="giverSet"
                label="수여자 이름"
                label-for="giver"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="giver"
                  v-validate.initial="veeRequired"
                  name="giverSchls"
                  placeholder="수여자 이름"
                  :disabled="freezing"
                  :state="isValid('giverSchls')"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="giverType === '직접'"
              md="5"
            >
              <b-form-group
                name="giverMobileSet"
                label="수여자 핸드폰"
                label-for="giverMobile"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="giverMobile"
                  v-validate.initial="veeMobile"
                  name="giverMobile"
                  :state="isValid('giverMobile')"
                  placeholder="숫자만"
                  :disabled="freezing"
                />
              </b-form-group>
            </b-col>
            <b-col md="9">
              <b-form-group
                name="senderSet"
                label="송금자명"
                label-for="sender"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="sender"
                  v-validate.initial="veeRequired"
                  name="sender"
                  placeholder="송금자명은 장학금 명칭으로 해 주세요. (예시 : 장로회장학금, 두렙돈장학금) "
                  :disabled="freezing"
                  :state="isValid('sender')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-list-group>
            <b-list-group-item variant="secondary">
              <strong>장학 기탁 가능한 대상:</strong>
            </b-list-group-item>
            <b-list-group-item variant="success">
              &nbsp;&nbsp;&nbsp;&nbsp;- 본인 또는 부모님이 임마누엘서울교회 출석중인 렘넌트
            </b-list-group-item>
            <b-list-group-item variant="success">
              &nbsp;&nbsp;&nbsp;&nbsp;- 만 30세 이하의 학생
            </b-list-group-item>
            <b-list-group-item variant="danger">
              &nbsp;&nbsp;&nbsp;&nbsp;- 가족/친척 관계간 기탁은 어렵습니다.
            </b-list-group-item>
          </b-list-group>
          <b-row>
            <b-col md="12">
              <donate-item
                v-for="(i, idx) in donateItems"
                :key="idx"
                :ref="'donateItem' + String(i[0])"
                :donate-item="i[1]"
                :donator="api.currentTerm() + '-' + mobile"
                :donation-num="i[0]"
                :disable-delete="donateItems.length == 1"
                :read-only="freezing"
                @deleteDonate="deleteDonateItem"
                @updateDonate="updateDonateItem"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="!freezing"
              md="12"
              class="text-right"
            >
              <button
                class="btn btn-warning btn-sm"
                @click="addDonateItem()"
              >
                장학 대상자 추가
              </button>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="12"
              class="text-left"
            >
              <h4><b>{{ part === '개인' ? nameKr : partName }}</b>&nbsp;이름으로 총 <b>{{ totalAmount| toCurrency }}</b>원을 기탁합니다.</h4>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col
              v-show="!freezing"
              class="mb-2"
              md="12"
            >
              <hr>
              <b-checkbox
                v-model="privacyChecked"
              >
                개인정보 활용에 동의 합니다. (Agree to personal information collection and usage agreement)
              </b-checkbox>
            </b-col>
          </b-row>
          <b-row align-h="end">
            <b-col
              v-show="!freezing && !registMode"
              md="6"
              class="text-center"
            >
              <b-button
                class="ml-2"
                variant="danger"
                @click="$refs.deleteModal.show()"
              >
                삭제
              </b-button>
            </b-col>
            <b-col
              v-show="!freezing"
              md="6"
              class="text-center"
            >
              <b-button
                block
                variant="primary"
                @click="validateUpdateDetailInfo()"
              >
                <h6><strong>등록</strong></h6>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import DonateItem from './donate/DonateItem'

/* 수정 할 수 있는사람
 * 작성자 / 관리자
 * 언제? 안잠겨있을때만
 */

export default {
  name: 'DonateRegist',
  components: { DonateItem },
  filters: {
    toCurrency: function (value) {
      if (typeof value !== 'number') {
        return value
      }
      var formatter = new Intl.NumberFormat('ko-KR', {
        style: 'currency',
        currency: 'KRW',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    }
  },
  props: {
    targetMobile: {
      type: String,
      default: ''
    },
    targetTerm: {
      type: String,
      default: ''
    },
    targetDonateId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      privacyChecked: false,
      registMode: true,
      donateId: '',
      api: api,
      donatePartOptions: api.DONATEPARTLIST,
      modalMobile: '',
      nameSchls: '',
      part: '',
      partName: '',
      giver: '',
      giverType: '황상배 목사',
      giverMobile: '',
      sender: '',
      donateItems: [[0, { type: '', rel: '', target: '', eachAmount: '', valid: false }]],
      nameKr: '',
      veeNameKr: {
        required: true,
        regex: /^(([가-힣][가-힣][가-힣]|[가-힣][가-힣][가-힣][가-힣]|[가-힣][가-힣]))$/
      },
      veeRequired: {
        required: true
      },
      title: '',
      mobile: '',
      veeMobile: {
        required: true,
        regex: /^(([0][1][1769][0-9][0-9][0-9][0-9][0-9][0-9][0-9])|([0][1][0][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]))$/
      },
      veeMobileOptional: {
        regex: /^(([0][1][1769][0-9][0-9][0-9][0-9][0-9][0-9][0-9])|([0][1][0][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]))$/
      },
      donateSeq: 0,
      totalAmount: 0,
      isReadOnly: true,
      candidates: []
    }
  },
  computed: {
    freezing () {
      return this.isReadOnly
    }
  },
  mounted () {
    // IECHECK
    if (window.document.documentMode) {
      alert('인터넷 익스플로러는 지원되지 않습니다. 크롬, 웨일, 사파리, 엣지 등을 사용해주세요 (Internet Explorer is not supported)')
      this.$router.push('/dashboard')
      return
    }
    if (this.targetMobile !== '' && this.targetTerm !== '' && this.targetDonateId !== '') {
      this.handleModalOk(this.targetMobile, this.targetTerm, this.targetDonateId)
    } else {
      /* 권한 체크 */
      this.unsetReadOnly()
      if (this.$route.query.check !== undefined) {
        this.$refs.modal.show()
      }
    }
    this.resetValidator()
  },
  methods: {
    showModal () {
      this.candidates = []
      this.$refs.modal.show()
    },
    unsetReadOnly () {
      let term = api.currentTerm()
      if (this.targetTerm !== '') {
        term = this.targetTerm
      }
      api.request('get', '/admin/control/lock?doc=donate&term=' + term)
        .then(response => {
          let data = response.data
          if (!data.lock || this.$store.getters.isRealSuper) {
            this.isReadOnly = false
          } else {
            /* lock이 되어 있어서 수정할 수 없음 */
            this.$refs.modalLock.show()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetValidator () {
      this.$validator.reset()
      this.donateItems.forEach(item => {
        this.$refs['donateItem' + String(item[0])][0].$validator.reset()
      })
    },
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    deleteDonateForm () {
      api.request('delete', '/donate/delete?donateId=' + this.donateId)
        .then(response => {
          var data = response.data
          alert(data.msg)
          this.$router.go()
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    clearModalMobile () {
      this.modalMobile = ''
    },
    selectCandidate (data) {
      this.handleModalSubmit(data)
      this.$nextTick(function () {
        this.resetValidator()
      })
      this.registMode = false
      this.isReadOnly = true
    },
    handleModalOk (mobile, term, docId) {
      if (term === '') {
        term = api.currentTerm()
      }
      if (mobile === '' || this.errors.has('modalMobile')) {
        alert('핸드폰 번호를 숫자만 입력해 주세요.')
      } else {
        // 실제로 있는지 체크! 없으면 안내
        this.resetValidator()
        api.request('get', '/donate/check?' + 'donateId=' + term + '-donate-' + mobile)
          .then(response => {
            var data = response.data
            // data 아마 배열
            if (data !== null && data['docs'] !== undefined && data['docs'].length > 0) {
              if (docId === undefined) {
                this.candidates = data['docs']
              } else {
                for (let i = 0; i < data['docs'].length; i++) {
                  if (data['docs'][i]['donateId'] === docId) {
                    this.selectCandidate(data['docs'][i])
                  }
                }
              }
            } else {
              alert('이번 학기에 기탁 하신 내역이 없습니다. 새로 작성해 주세요.')
              this.handleModalSubmit(null)
            }
          })
          .catch(error => {
            if (error.response !== undefined) {
              alert(error.response.data.error)
            }
            console.log(error)
            this.handleModalSubmit(null)
          })
      }
    },
    handleModalSubmit (data) {
      if (data !== null) {
        this.mobile = data.mobile
        this.donateId = data.donateId
        this.part = data.part
        this.partName = data.partName
        this.nameKr = data.nameKr
        this.title = data.title
        this.nameSchls = data.nameSchls
        this.giver = data.giver === '황상배 목사' ? '' : data.giver
        this.giverMobile = data.giverMobile ? data.giverMobile : ''
        if (this.giver !== '') {
          this.giverType = '직접'
        }
        this.sender = data.sender
        this.totalAmount = data.totalAmount
        let tempDonateItems = []
        for (let index = 0; index < data.targets.length; index++) {
          let donateItem = data.targets[index]
          donateItem.valid = true
          tempDonateItems.push([index, data.targets[index]])
        }
        if (tempDonateItems.length > 0) {
          this.donateSeq = tempDonateItems.length - 1
          this.donateItems = tempDonateItems
        }
      } else {
        this.clearModalMobile()
      }
      this.$refs.modal.hide()
    },
    calcTotalAmount () {
      let total = 0
      for (let index = 0; index < this.donateItems.length; index++) {
        if (this.donateItems[index][1].valid) {
          total += Number(this.donateItems[index][1].eachAmount)
        }
      }
      this.totalAmount = total
    },
    deleteDonateItem (donateNum) {
      for (let index = 0; index < this.donateItems.length; index++) {
        if (this.donateItems[index][0] === donateNum) {
          this.donateItems.splice(index, 1)
          break
        }
      }
      this.calcTotalAmount()
    },
    updateDonateItem (donateNum, donateItem) {
      let total = 0
      for (let index = 0; index < this.donateItems.length; index++) {
        if (this.donateItems[index][0] === donateNum) {
          this.donateItems[index][1] = donateItem
        }
        if (this.donateItems[index][1].valid) {
          total += Number(this.donateItems[index][1].eachAmount)
        }
      }
      this.totalAmount = total
    },
    addDonateItem: function () {
      this.donateSeq += 1
      this.donateItems.push([this.donateSeq, { type: '', rel: '', target: '', eachAmount: '', valid: false }])
    },
    alertSuccess () {
      alert('기탁 완료!')
      if (this.registMode) {
        this.$router.push('/dashboard')
      } else {
        this.isReadOnly = true
      }
    },
    alertFail (msg) {
      alert(msg)
    },
    alertRetry () {
      alert('빨간색으로 표시된 상자를 확인해주세요.(Check all the red boxes)')
    },
    alertRetryPrivacy () {
      alert('개인정보 활용에 동의해주세요 (Please check personal information collection and usage agreement)')
    },
    donateItemValid () {
      for (let index = 0; index < this.donateItems.length; index++) {
        if (!this.donateItems[index][1].valid) {
          return false
        }
      }
      return true
    },
    validateUpdateDetailInfo () {
      this.donateItems.forEach(item => {
        this.$refs['donateItem' + String(item[0])][0].$validator.validate()
      })
      this.$validator.validate()
        .then(valid => {
          this.updateDetailInfo(valid)
        })
    },
    updateDetailInfo (valid) {
      if (!valid || this.totalAmount <= 0 || (this.part !== '개인' && this.partName === '') || !this.donateItemValid()) {
        this.alertRetry()
        return
      }
      if (!this.privacyChecked) {
        this.alertRetryPrivacy()
        return
      }
      // post arg 세팅
      var postArg = {}
      postArg['donateId'] = api.docId('donate', this.mobile)
      postArg['oldDonateId'] = this.donateId
      postArg['part'] = this.part
      postArg['partName'] = this.partName
      postArg['nameKr'] = this.nameKr
      postArg['mobile'] = this.mobile
      postArg['title'] = this.title
      postArg['nameSchls'] = this.nameSchls.replace(/:/gi, ' ')
      postArg['giver'] = this.giver === '' ? '황상배 목사' : this.giver
      postArg['giverMobile'] = this.giverMobile
      postArg['sender'] = this.sender
      postArg['totalAmount'] = this.totalAmount
      postArg['targets'] = []
      postArg['modifiedDate'] = api.currentUnixTime()
      for (let index = 0; index < this.donateItems.length; index++) {
        postArg['targets'].push({ 'type': this.donateItems[index][1].type, 'rel': this.donateItems[index][1].rel, 'target': this.donateItems[index][1].target, 'eachAmount': Number(this.donateItems[index][1].eachAmount) })
      }

      api.request('post', '/donate/regist', postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
             400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.alertSuccess()
            this.$emit('donateUpdated')
            this.resetValidator()
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
